import React from 'react';
import { useDisclosure } from '@withjoy/joykit';

import CurrencySelectorModal, { CurrencySelectorTrigger } from './CurrencySelectorModal';

type CurrencySelectorProps = Readonly<{
  isEnabled: boolean;
}>;

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({ isEnabled }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!isEnabled) return null;

  const handleTriggerClick = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  return (
    <CurrencySelectorModal
      isOpen={isOpen}
      onClose={onClose}
      trigger={
        <CurrencySelectorTrigger
          isOpen={isOpen}
          onClick={handleTriggerClick}
        />
      }
    />
  );
};
